import React, { useState, useEffect } from "react";
import { AgGridReact } from "ag-grid-react";
import axios from "axios";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";




const ProofManager = () => {
  const [proofType, setProofType] = useState("");
  const [proofName, setProofName] = useState("");
  const [rowData, setRowData] = useState([]);
  const [errors, setErrors] = useState("");
  const [editingProof, setEditingProof] = useState(null);
  const [alert, setAlert] = useState({ message: "", type: "" });


  

  useEffect(() => {
    axios
      .get("https://calendarservicesapi.nithra.mobi/proof")
      .then((response) => {
        setRowData(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);


    useEffect(() => {
            document.title = 'Add Proof - Calendar Services';
          }, []);


          
            useEffect(() => {
              if (alert.message) {
                const timer = setTimeout(() => setAlert({ message: "", type: "" }), 3000);
                return () => clearTimeout(timer);
              }
            }, [alert]);

  const columnDefs = [
    { headerName: "S.No", valueGetter: (params) => params.node.rowIndex + 1 },
    {
      headerName: "Actions",
      cellRenderer: (params) => (
        <div className="flex space-x-2">
          <button
            className="text-blue-500 hover:underline"
            onClick={() => handleEdit(params.data)}
          >
            Edit
          </button>
          <button
            className="text-red-500 hover:underline"
            onClick={() => handleDelete(params.data.id)}
          >
            Delete
          </button>
        </div>
      ),
    },
    { headerName: "Proof Name", field: "proof_name", flex: 1 },
    {
      headerName: "Proof Category",
      field: "proof_type",
      flex: 1,
      valueFormatter: (params) => {
        switch (params.value) {
          case 1:
            return "ID Proof";
          case 2:
            return "Address Proof";
          case 3:
            return "Both";
          default:
            return "Unknown";
        }
      },
    },
    { headerName: "Added By", field: "cby", flex: 1, sortable: true, filter: true, resizable: true },
  ];

  const handleSave = () => {
    const loggedInUser = localStorage.getItem("username");

    if (!proofType.trim() || !proofName.trim()) {
      setErrors("Both Proof Name and Category are required.");
      return;
    }

    const proofTypeInt = proofType === "ID Proof" ? 1 : proofType === "Address Proof" ? 2 : 3;

    if (editingProof) {
      const updatedProof = { id: editingProof.id, proof_type: proofTypeInt, proof_name: proofName, mby: loggedInUser };

      axios
        .put(`https://calendarservicesapi.nithra.mobi/proof/${editingProof.id}`, updatedProof)
        .then(() => {
          setRowData((prevData) =>
            prevData.map((row) =>
              row.id === editingProof.id ? { ...row, proof_type: proofTypeInt, proof_name: proofName } : row
            )
          );
          resetForm();
          setAlert({ message: "Proof updated successfully!", type: "success" });
        })
        .catch((error) => {
          console.error("Error updating proof:", error);
          setAlert({ message: "Error updating proof.", type: "error" });
        });
    } else {
      const newProof = { proof_type: proofTypeInt, proof_name: proofName, cby: loggedInUser };

      axios
        .post("https://calendarservicesapi.nithra.mobi/proof", newProof)
        .then((response) => {
          setRowData((prevData) => [...prevData, { ...newProof, id: response.data.id }]);
          resetForm();
          setAlert({ message: "Proof added successfully!", type: "success" });
        })
        .catch((error) => {
          console.error("Error adding proof:", error);
          setAlert({ message: "Error adding proof.", type: "error" });
        });
    }
  };

  const handleEdit = (proof) => {
    setEditingProof(proof);

    const proofTypeName =
      proof.proof_type === 1 ? "ID Proof" : proof.proof_type === 2 ? "Address Proof" : "Both";

    setProofType(proofTypeName);
    setProofName(proof.proof_name);
    setErrors("");
    window.scrollTo({ top: 0, behavior: 'smooth' });

  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this proof?")) {
      axios
        .delete(`https://calendarservicesapi.nithra.mobi/proof/${id}`)
        .then(() => {
          setRowData((prevData) => prevData.filter((row) => row.id !== id));
          setAlert({ message: "Proof deleted successfully!", type: "success" });
          
        })
        .catch((error) => {
          console.error("Error deleting proof:", error);
          setAlert({ message: "Error deleting proof.", type: "error" });
        });
    }
  };

  const resetForm = () => {
    setEditingProof(null);
    setProofType("");
    setProofName("");
    setErrors("");
  };

  return (
    <div className="bg-gray-100 p-6">
      <div className="max-w-3xl mx-auto mt-8 bg-white shadow-md rounded mb-4">
        <div className="bg-teal-500 text-white px-6 py-3 rounded-t">
          <h2 className="text-xl font-bold">Add Proof</h2>
        </div>
        <div className="p-4">
          <div>
            <label className="block text-gray-700 font-semibold mb-4">
              Proof Type<span className="text-red-500">*</span>
            </label>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <select
                  value={proofType}
                  onChange={(e) => setProofType(e.target.value)}
                  className="w-full p-3 border rounded mt-2"
                >
                  <option value="">Select Proof Type</option>
                  <option value="ID Proof">ID Proof</option>
                  <option value="Address Proof">Address Proof</option>
                  <option value="Both">Both</option>
                </select>
              </div>
              <div>
                <input
                  type="text"
                  value={proofName}
                  onChange={(e) => setProofName(e.target.value)}
                  className="w-full p-3 border rounded mt-2"
                  placeholder="Enter Proof Name"
                />
              </div>
            </div>
            {errors && <p className="text-red-500 text-sm mt-1">{errors}</p>}
          </div>
          <div className="flex justify-end">
            <button
              onClick={handleSave}
              className="mt-5 bg-blue-500 text-white px-6 py-2 rounded shadow hover:bg-blue-600 transition"
            >
              {editingProof ? "Update" : "Save"}
            </button>
          </div>
        </div>
      </div>

      <div className="max-w-5xl mx-auto mt-8 bg-white shadow-md rounded">
        <div className="p-6">
          <h2 className="text-blue-600 text-xl font-bold mb-6">View Proofs</h2>
          <div
            className="ag-theme-alpine"
            style={{ height: 500, width: "100%" }}
          >
            <AgGridReact
              rowData={rowData}
              columnDefs={columnDefs}
              pagination={true}
              paginationPageSize={10}
              defaultColDef={{ sortable: true, filter: true, editable:true }}
            />
          </div>
        </div>
      </div>
      {alert.message && (
        <div
          className={`fixed top-20 right-4 px-5 py-3 text-white rounded-lg shadow-lg z-50 ${
            alert.type === "success" ? "bg-green-500" : "bg-red-500"
          }`}
        >
          <span>{alert.message}</span>
        </div>
      )}
    </div>
  );
};

export default ProofManager;
